export default {
    drawerWidth: 240
};
